// extracted by mini-css-extract-plugin
export default {"cls1":"JrxCTTqIeyD9QXhML93q","cls2":"tgjVeay8USQxu7hARbO0 JrxCTTqIeyD9QXhML93q"};